<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
        </div>
      </div>
<!--      <div class="btnWrap visible" @click="setParent()">-->
<!--        <button type="button" class="callTerms">확인</button>-->
<!--      </div>-->
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '본인인증 성공',
        prevUrl: '/'
      },
      encCode: '',
      EncodeData: ''
    }
  },
  computed: {
    ...mapGetters('identity', [
      'getEncCode',
      'getUrl',
      'getIsTemp',
      'getSuccess'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_CHECKED_PW',
      'IDENTITY_CHECK'
    ]),
    ...mapMutations('identity', [
      'SET_ENC_CODE',
      'SET_IDENTITY_SUCCESS'
    ]),
    ...mapActions('identity', [
      'IDENTITY_SUCCESS_POST'
    ]),
    // getUrlParams () {
    //   const params = {}
    //   window.location.search.replace(
    //     /[?&]+([^=&]+)=([^&]*)/gi,
    //     (str, key, value) => { params[key] = value }
    //   )
    //   return params
    // },
    async fetchData () {
      // console.log('url에서 param 가져오기 - 1번')
      // const param = this.getUrlParams()
      const EncodeData = sessionStorage.getItem('enc_data')
      const url = localStorage.getItem('url')

      if (EncodeData !== null || EncodeData !== '') {
        this.SET_ENC_CODE(EncodeData)
        this.EncodeData = this.getEncCode
        try {
          const encCode = {
            EncodeData: this.EncodeData
          }
          console.log('this.getUrl: ', this.getUrl)
          await this.IDENTITY_SUCCESS_POST(encCode)
            .then(() => {
              if (this.getUrl.indexOf('authorized') >= 0 || url.indexOf('authorized') >= 0) {
                this.$router.push('/formData')
              } else if (this.getUrl.indexOf('isTemp') >= 0 || url.indexOf('isTemp') >= 0) {
                console.log('this.isTemp: ', this.getIsTemp)
                console.log('this.getSuccess: ', this.getSuccess)
                if (this.getIsTemp.name !== this.getSuccess.name || this.getIsTemp.birthDate.replace(/[^0-9]/g, '') !== this.getSuccess.birthDate) {
                  this.getIsTemp.fail = true
                  console.log('정보다르다')
                  this.SET_POPUP(true)
                  this.popupSet.count = 'another'
                  this.popupSet.closeType = 'action'
                  this.popupSet.closeLink = '/'
                  this.popupSet.nextLink = '/'
                  this.popupSet.content = '본인인증 정보와 기존 정보가 일치하지 않습니다. 정보를 확인해주세요.'
                  /* 본인인증 정보 초기화 */
                  const userInfo = {
                    name: '',
                    birthDate: '',
                    gender: '',
                    mobileno: '',
                    dupInfo: ''
                  }
                  this.SET_IDENTITY_SUCCESS(userInfo)
                  return false
                } else {
                  this.$router.push('/passwordFindCertifyNext')
                }
              } else if (this.getUrl.indexOf('modify') >= 0 || url.indexOf('modify') >= 0) {
                this.SET_CHECKED_PW(true)
                this.$router.push('/modifyUser/modify')
              }
            })
        } catch (e) {
          console.log('error: ', e)
          this.SET_POPUP(true)
          this.popupSet.count = 'another'
          this.popupSet.content = '잘못된 접근입니다.'
          this.popupSet.closeType = 'action'
          this.popupSet.closeLink = '/'
          this.popupSet.nextLink = '/'
        } finally {
        }
      } else {
        this.SET_POPUP(true)
        this.popupSet.count = 'another'
        this.popupSet.content = '잘못된 접근입니다.'
        this.popupSet.closeType = 'action'
        this.popupSet.closeLink = '/'
        this.popupSet.nextLink = '/'
      }
    }
    // setParent () {
    //   const param = this.getUrlParams()
    //   this.SET_ENC_CODE(param.EncodeData)
    //   window.opener.location.reload()
    //   self.close()
    // }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  created () {
    this.fetchData()
  },
  beforeDestroy () {
    this.SET_POPUP(false)
  }
}
</script>

<style lang="scss" scoped>
</style>
